import { CircleButtonColorStyleSet } from './CircleButtonTypes';

export const activeColor = '$color-primary-a2';

export const variantStyleObject: CircleButtonColorStyleSet = {
  accent: {
    active: {
        iconColor: activeColor,
    },
    inactive: {
        iconColor: '$color-primary-a2',
    },
  },
  default: {
    active: {
        iconColor: activeColor,
    },
    inactive: {
        iconColor: '$color-primary-a3',
    },
  },
  float: {
    active: {
        iconColor: activeColor,
    },
    inactive: {
        iconColor: '$color-primary-a3',
    },
  },
  inverse: {
    active: {
        iconColor: activeColor,
    },
    inactive: {
        iconColor: '$color-primary-c1',
    },
  },
  outline: {
    active: {
        iconColor: activeColor,
    },
    inactive: {
        iconColor: '$color-primary-c1',
    },
  },
};